(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zellora-welcome-popup"]) return;
  try {
    
(() => {
  const dialog = document.getElementById('ZelloraWelcome');
  if (!dialog) return;
  const key = 'zellora_welcome_v1';
  const success = dialog.querySelector('[data-welcome-success]');
  const error = dialog.querySelector('[data-welcome-error]');
  const read = () => { try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch { return {}; } };
  const save = value => { try { localStorage.setItem(key, JSON.stringify(value)); } catch {} };
  const show = () => { if (!dialog.open) dialog.showModal(); };
  dialog.querySelector('.zellora-welcome__close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (!success) save({ ...read(), closedAt: Date.now() });
  });
  if (success) { save({ subscribed: true }); show(); return; }
  if (error) { show(); return; }
  const state = read();
  if (dialog.dataset.editor === 'true' || state.subscribed || (state.closedAt && Date.now() - state.closedAt < 604800000)) return;
  window.setTimeout(() => {
    if (!document.querySelector('dialog[open]')) show();
  }, Number(dialog.dataset.delay) || 6000);
})();

  } catch(e) { console.error(e); }
})();
})();
